export class UserUtilizationIconAndColor {

    /**
     * @description Klasa zaokreślajaca ikonę i jej kolor w rapotorach wydaności. 
     */
    constructor(icon: string, color: string) {
        this.icon = icon;
        this.color = color;
    }

    icon: string;
    color: string;
}

